// extracted by mini-css-extract-plugin
export var deleteModal = "_f6-0";